import React, { useState } from 'react';
import axios from 'axios';

const DamageComparison = () => {
  const [beforeImage, setBeforeImage] = useState(null);
  const [afterImage, setAfterImage] = useState(null);
  const [results, setResults] = useState({ before: null, after: null });
  const [differences, setDifferences] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleImageUpload = (e, type) => {
    const file = e.target.files[0];
    if (type === 'before') setBeforeImage(file);
    else setAfterImage(file);
  };

  const compareDamages = (before, after) => {
    const beforeMap = new Map();
    before.damages.forEach(d => {
      beforeMap.set(d.part.toLowerCase(), d.severity.toLowerCase());
    });

    const newOrWorsened = after.damages.filter(d => {
      const part = d.part.toLowerCase();
      const severity = d.severity.toLowerCase();

      if (!beforeMap.has(part)) return true;

      const beforeSeverity = beforeMap.get(part);
      const severityLevels = ['leve', 'moderado', 'severo'];
      return severityLevels.indexOf(severity) > severityLevels.indexOf(beforeSeverity);
    });

    return newOrWorsened;
  };

  const analyzeImages = async () => {
    if (!beforeImage || !afterImage) return alert('Subí ambas imágenes');
    setLoading(true);

    try {
      // Subir imagen al backend y obtener ruta local
      const uploadImage = async (file) => {
        const formData = new FormData();
        formData.append('image', file);
        const res = await axios.post('http://localhost:4005/api/upload-image', formData);
        return res.data.path;
      };

      const [beforePath, afterPath] = await Promise.all([
        uploadImage(beforeImage),
        uploadImage(afterImage),
      ]);

      // Enviar rutas a Arya para análisis
      const res = await axios.post('http://localhost:4005/api/analyze-image', {
        beforePath,
        afterPath,
        manufacturer: 'Ford',
        model: 'Mustang',
      });

      // Adaptar respuesta al formato esperado por el frontend
      setResults({
        before: { damages: res.data.before },
        after: { damages: res.data.after },
      });

      const nuevosDanios = compareDamages(
        { damages: res.data.before },
        { damages: res.data.after }
      );
      setDifferences(nuevosDanios);
    } catch (err) {
      console.error('Error al analizar imágenes:', err);
      alert('Hubo un error al analizar las imágenes');
    } finally {
      setLoading(false);
    }
  };


  const renderDamageList = (data) => {
    if (!data || !data.damages || data.damages.length === 0) return <p>No se detectaron daños.</p>;
    return (
      <ul>
        {data.damages.map((d, i) => (
          <li key={i}>
            <strong>{d.part}</strong>: {d.severity} ({d.estimated_cost})
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Comparador de daños en unidad</h2>

      <div style={{ marginBottom: '1rem' }}>
        <label>Imagen Antes:</label>
        <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, 'before')} />
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <label>Imagen Después:</label>
        <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, 'after')} />
      </div>

      <button onClick={analyzeImages} disabled={loading}>
        {loading ? 'Analizando...' : 'Analizar imágenes'}
      </button>

      {results.before && results.after && (
        <div style={{ marginTop: '2rem' }}>
          <h3>Resultados</h3>
          <div style={{ display: 'flex', gap: '2rem' }}>
            <div>
              <h4>Antes</h4>
              <img src={URL.createObjectURL(beforeImage)} alt="Antes" width="300" />
              {renderDamageList(results.before)}
            </div>
            <div>
              <h4>Después</h4>
              <img src={URL.createObjectURL(afterImage)} alt="Después" width="300" />
              {renderDamageList(results.after)}
            </div>
          </div>

          {differences.length > 0 && (
            <div style={{ marginTop: '2rem' }}>
              <h4>🆕 Daños nuevos o agravados</h4>
              <ul>
                {differences.map((d, i) => (
                  <li key={i}>
                    <strong>{d.part}</strong>: {d.severity} ({d.estimated_cost})
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DamageComparison;
